import { CenterItem, Row } from '@components/LinearLayout';
import { H2, H5 } from '@components/Typography';

import styled from 'styled-components';

export const EventRoot = styled.div``;

export const AgendaImageSection = styled.div<{ $padding?: string }>`
  display: grid;
  grid-template-columns: 59% 41%;
  padding: ${({ $padding }) => $padding};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    display: flex;
    flex-direction: column;
  }
`;

export const ImageWrapper = styled.div`
  height: 59rem;
  border-bottom-right-radius: 6rem;
  overflow: hidden;
  position: relative;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    height: 92vh;
    border-bottom-right-radius: 0;
  }
`;

export const AgendaTextWrapper = styled.div`
  padding: 10rem 15rem 0 10rem;
  height: 59rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    margin: auto;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0;
    height: 39rem;
  }
`;

export const AgendaImage = styled.img<{ objectFit?: string }>`
  height: 100%;
  width: 100%;
  object-fit: ${({ objectFit }) => objectFit || 'cover'};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    object-position: right;
  }
`;
export const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.color.mobilityGrey};
  opacity: 0.4;
`;

export const TagsOverlay = styled(CenterItem)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const TagsWrapper = styled(Row)`
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.3rem;
  width: 50%;
`;
export const Track = styled.div<{ $color: string; $isSelected: boolean }>`
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ $color, $isSelected, theme }) =>
    $isSelected ? theme.color.mobilityGrey : $color};
  padding: 0.6rem 1.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.radius50};
  font-size: ${({ theme }) => theme.fontSize.size18};
  text-align: center;
  transition: background-color 600ms cubic-bezier(0.4, 0.47, 0.13, 0.88);
  &:hover {
    background-color: ${({ theme }) => theme.color.mobilityGrey};
    cursor: pointer;
  }
`;

export const AlignedLeftText = styled(H5)`
  text-align: left;
  color: ${({ theme }) => theme.color.mobilityGrey};
+
`;

export const Title = styled(H2)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  padding-bottom: 0.5rem;
`;

export const TextWrapper = styled.div`
  width: 43rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  padding-left: 1.5rem;
  padding-bottom: 1.3rem;
  padding-top: 0.3rem;
  margin-right: auto;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 100%;
    display: grid;
    place-items: center;
    padding: 0 2rem;
  }
`;

/** Wrapper 12 col, mobile 8 */
export const SectionGrid = styled.section<{
  $max?: number;
}>`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  column-gap: 40px;
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 1080px) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 16px;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
    column-gap: 14px;
  }
`;

export const GridSpan = styled.div<{ start?: number; span?: number }>`
  grid-column: ${({ start = 1, span = 12 }) => `${start} / span ${span}`};
  width: 100%;

  & > * {
    max-width: 100% !important;
  }

  @media (max-width: 768px) {
    grid-column: 1 / -1;
  }
`;

export const StickyWrapper = styled.div`
  position: sticky;
  height: 100%;
`;
